/**
 * Bildregistry der zwei Buyer Personas aus Kapitel 2.
 *
 * Derselbe 3D-Trickfilmstil wie die Kapitelillustrationen — eine Persona ist
 * eine erfundene Person, und ein Foto würde eine echte behaupten. Die Dateien
 * liegen als AVIF (klein) und WebP (Fallback) in src/assets/images/konzept/
 * und sind 480px breit; gezeigt werden sie als Kreis mit 88px Durchmesser.
 *
 * Statische Importe wie in `illustrationen.js`: Nur so nimmt der Webpack-Build
 * von CRA die Dateien mit und versieht sie mit Hash-Namen.
 */

import lenaAvif from '../../../../assets/images/konzept/persona-lena.avif'
import lenaWebp from '../../../../assets/images/konzept/persona-lena.webp'
import michaelAvif from '../../../../assets/images/konzept/persona-michael.avif'
import michaelWebp from '../../../../assets/images/konzept/persona-michael.webp'

export const PERSONAS = {
	lena: { avif: lenaAvif, webp: lenaWebp },
	michael: { avif: michaelAvif, webp: michaelWebp }
}
